<template>
  <div>
    <vs-sidebar
      position-right
      parent="body"
      default-index="1"
      color="primary"
      class="sidebarFilter"
      spacer
      v-model="sidebarState"
      :clickNotClose="true"
    >
      <vs-button
        color="danger"
        class="p-3"
        type="flat"
        @click="clearFilter('x')"
        >x</vs-button
      >
      <vx-card class="h-full m-0">
        <h6 class="mb-2">{{ $t("filters.group") }}</h6>
        <v-select
          class="mb-3 width-select-filter"
          v-model="formData.group"
          label="group_name"
          :options="listGroup"
          :clearable="false"
          multiple
        ></v-select>
        <h6 class="mb-2">{{ $t("filters.ingredients") }}</h6>
        <LazySelect
          ref="groupIngridientsSelect"
          multiple
          v-model="formData.component"
          :options="GET_INGREDIENTS"
          :state="formData.component"
          :fetch="FETCH_INGREDIENTS"
          :getOptionLabel="(el) => el.name"
        />

        <h6 class="my-2">{{ $t("filters.region") }}</h6>
        <v-select
          class="mb-3 width-select-filter"
          v-model="formData.parent_region"
          label="region_kir"
          :options="parentRegions"
          :placeholder="$t('all_regions')"
          @input="getChildRegionsList"
          :clearable="false"
          multiple
        ></v-select>

        <h6 class="mb-2">{{ $t("modules.analytics.object_info.area") }}</h6>
        <v-select
          class="mb-3 width-select-filter"
          v-model="formData.region"
          label="region_kir"
          :placeholder="$t('all_districts')"
          multiple
          :options="childRegions"
          :clearable="false"
          @input="getObjects"
        ></v-select>

        <h6 class="mb-2">{{ $t("filters.objects") }}</h6>
        <LazySelect
          ref="objectCompaniesSelect"
          multiple
          v-model="formData.objectSelected"
          :filters="selectedDistrictIds"
          :state="formData.objectSelected"
          :options="GET_OBJECT_COMPANIES"
          :fetch="FETCH_OBJECT_COMPANIES"
          :getOptionLabel="(el) => el.title"
        />

        <h6 class="my-2">{{ $t("filters.category") }}</h6>
        <v-select
          class="mb-3"
          label="title"
          v-model="formData.danger_category"
          ref="infSelect"
          :get-option-label="(item) => item.title"
          :options="categoryList"
          multiple
        />

        <h6 class="mb-2">{{ $t("filters.by_status") }}</h6>
        <v-select
          class="mb-3 width-select-filter"
          v-model="formData.status"
          :options="statuses"
          label="status_name"
          :clearable="false"
          multiple
        ></v-select>
        <h6 class="mb-2">{{ $t("filters.status_normative") }}</h6>
        <v-select
          class="mb-3 width-select-filter"
          v-model="formData.normative_is_active"
          :options="normatives"
          label="status_name"
          :clearable="false"
          :get-option-label="(item) => item.title"
          :reduce="(item) => item.value"
          multiple
        ></v-select>
        <h6 class="mb-2">{{ $t("filters.znacheniya") }}</h6>
        <v-select
          class="mb-3 width-select-filter"
          v-model="formData.values"
          :options="values"
          label="status_name"
          :clearable="false"
          :get-option-label="(item) => item.title"
          :reduce="(item) => item.value"
          multiple
        ></v-select>

        <h6 class="mb-3">{{ $t("filters.interval_time") }}</h6>
        <vs-checkbox class="mb-3" v-model="formData.ignore_date"
          >{{ $t("filters.data_otbor") }}
        </vs-checkbox>
        <div class="vx-row">
          <div class="vx-col w-1/2">
            <span class="mb-2 ml-1">{{ $t("date_c") }}</span>
            <flat-pickr
              :disabled="formData.ignore_date"
              class="w-full"
              v-model="formData.start_date"
              :config="config"
            />
          </div>
          <div class="vx-col w-1/2">
            <label class="mb-2 ml-1">{{ $t("date_p") }}</label>
            <flat-pickr
              :disabled="formData.ignore_date"
              class="w-full"
              v-model="formData.end_date"
              :config="config"
            />
          </div>
        </div>
        <div class="w-full mt-4">
          <div class="vx-row">
            <div class="vx-col w-1/2">
              <vs-button
                class="w-full"
                color="gray"
                type="filled"
                @click="clearFilter"
                >{{ $t("filters.reset") }}
              </vs-button>
            </div>
            <div class="vx-col w-1/2">
              <vs-button
                class="w-full"
                color="primary"
                type="filled"
                @click="submitHandler"
                >{{ $t("filters.apply") }}
              </vs-button>
            </div>
          </div>
        </div>
      </vx-card>
    </vs-sidebar>

    <vs-button
      @click="sidebarState = true"
      class="transform z_index"
      color="primary"
      icon="icon-filter"
      size="small"
      iconPack="feather"
    />
  </div>
</template>

<script>
import moment from "moment";
import vSelect from "vue-select";
import VInfSelect from "@/components/infiniteScroll/v-inf-select.vue";
import flatPickr from "vue-flatpickr-component";
import { Russian } from "flatpickr/dist/l10n/ru.js";
import LazySelect from "@/components/LazySelect/LazySelect.vue";
import { mapActions, mapGetters } from "vuex";
import "flatpickr/dist/flatpickr.css";

export default {
  components: {
    vSelect,
    LazySelect,
    flatPickr,
    VInfSelect,
  },
  props: {
    ecology_type: Object,
    filter_status_id: Number,
  },
  data: () => ({
    selectedDistrictIds: {
      region_id: [999],
      district: [999],
    },
    loadingObjects: true,
    sidebarState: false,
    formData: {
      type_dail: null,
      danger_category: [],
      values: [],
      component: [],
      normative_is_active: [],
      district: [],
      region: [],
      parent_region: [],
      status: [],
      group: [],
      objectSelected: [],
      start_date: moment().format("DD-MM-YYYY"),
      end_date: moment().format("DD-MM-YYYY"),
      ignore_date: true,
    },
    categoryList: [
      {
        title: "1",
      },
      {
        title: "2",
      },
      {
        title: "3",
      },
      {
        title: "4",
      },
      {
        title: "0",
      },
    ],
    parentRegions: [],
    childRegions: [],
    objectsList: [],
    groupIngridient: false,
    objectsCount: 0,
    listGroup: [],
    ecology_type_id: 1,
    ecology_type_list: [
      {
        color: "success",
        display_name: "Воздух",
        id: 1,
        name: "air",
      },
      {
        color: "danger",
        display_name: "Почва",
        id: 2,
        name: "soil",
      },
      {
        color: "primary",
        display_name: "Вода",
        id: 3,
        name: "water",
      },
    ],
    ingridients: {
      results: [],
    },
    statuses: [],
    values: [],
    normatives: [
      {
        title: "Активный",
        value: "true",
      },
      {
        title: "Неактивный",
        value: "false",
      },
    ],

    config: {
      dateFormat: "d.m.Y",
      maxDate: new Date(),
      defaultDate: new Date(),
      locale: Russian,
    },
  }),

  computed: {
    ...mapGetters("additional", ["GET_INGREDIENTS", "GET_OBJECT_COMPANIES"]),
    getStatus() {
      return this.statuses.find((el) => el.id === this.filter_status_id);
    },
  },
  async mounted() {
    if (
      this.$route.name === "csak_Air" ||
      this.$route.name === "CSAK_Moderation_Air"
    ) {
      this.formData.type_dail = "air";
      this.ecology_type_id = 1;
      this.values = [
        {
          title: "Нормальный",
          value: "1",
        },
        {
          title: "Загрязнение",
          value: "0",
        },
        {
          title: "бесконечность",
          value: "2",
        },
      ];
    }
    if (
      this.$route.name === "CSAK_Water" ||
      this.$route.name === "CSAK_Moderation_Water"
    ) {
      this.formData.type_dail = "water";
      this.ecology_type_id = 3;
      this.values = [
        {
          title: "Нормальный",
          value: "normal",
        },
        {
          title: "Превышено",
          value: "exceeded",
        },
        {
          title: "Заниженный",
          value: "understated",
        },
        {
          title: "Нет данных",
          value: "none_data",
        },
      ];
    }
    if (
      this.$route.name === "CSAK_Ground" ||
      this.$route.name === "CSAK_Moderation_Ground"
    ) {
      this.formData.type_dail = "earth";
      this.ecology_type_id = 2;
      this.values = [
        {
          title: "Нормальный",
          value: "normal",
        },
        {
          title: "Превышено",
          value: "exceeded",
        },
        {
          title: "Заниженный",
          value: "understated",
        },
        {
          title: "Нет данных",
          value: "none_data",
        },
      ];
    }

    // this.objectFetchWithFilter();
  },
  watch: {
    "formData.group"(val) {
      let group_list = val.map((item) => item.id);
      this.$store
        .dispatch("libraries/fetchGroupsComponentsByEcologyTypeIngridient", {
          group_list: group_list,
          page_size: 1000,
        })
        .then((res) => {
          this.ingridients = res.data;
        });
      if (val.length > 0) {
        this.groupIngridient = false;
      } else {
        this.formData.component = [];
        this.groupIngridient = true;
      }
    },

    async sidebarState(val) {
      if (!val) return;
      if (this.$store.state.libraries.parentRegions.length === 0) {
        await this.$store.dispatch("libraries/fetchParentRegions").then(() => {
          this.parentRegions.push(...this.$store.state.libraries.parentRegions);
        });
      } else {
        this.parentRegions.push(...this.$store.state.libraries.parentRegions);
      }
      await this.$store
        .dispatch("emissions/fetchAllStatusesEmissions", { page_size: 1000 })
        .then((res) => {
          this.statuses = res.data;
        })
        .catch((err) => {
          console.error(err);
        });

      this.getGroups();
      this.fetchChildRegions({ region_id: [999] });
    },
  },
  methods: {
    ...mapActions("additional", [
      "FETCH_INGREDIENTS",
      "FETCH_OBJECT_COMPANIES",
    ]),

    getGroups() {
      this.$store
        .dispatch("libraries/fetchGroupsComponentsByEcologyType", {
          ecology_type_id: this.ecology_type_id,
          page_size: 20,
        })
        .then((res) => {
          this.listGroup.push(...res.data.data);
        });
    },

    getObjects(district) {
      if (!district.length) {
        this.selectedDistrictIds.district = [999];
        return;
      }
      this.formData.objectSelected = [];
      this.selectedDistrictIds.district = district.map((item) => item.id);
    },

    submitHandler() {
      let filterObject1 = { district: [] };
      let filterObject2 = { status: [] };
      let filterObject3 = { region_id: [] };
      let filterObject4 = { object: [] };
      let filterObject5 = { group: [] };
      let filterObject6 = { normative_is_active: [] };
      let filterObject7 = { values: [] };
      let filterObject8 = { component: [] };
      let filterObject9 = { danger_category: [] };
      let filterObject = new Object();
      let {
        parent_region,
        region,
        status,
        objectSelected,
        group,
        normative_is_active,
        values,
        component,
        type_dail,
        danger_category,
      } = this.formData;
      if (danger_category.length > 0) {
        danger_category.map((item) => {
          filterObject9.danger_category.push(item.title);
        });
      }

      if (parent_region.length > 0) {
        parent_region.map((item) => {
          filterObject3.region_id.push(item.id);
        });
      }
      if (region.length > 0) {
        region.map((item) => {
          filterObject1.district.push(item.id);
        });
      }
      if (status.length > 0) {
        status.map((item) => {
          filterObject2.status.push(item.id);
        });
      }

      if (objectSelected.length > 0) {
        objectSelected.map((item) => {
          filterObject4.object.push(item.id);
        });
      }
      if (group.length > 0) {
        group.map((item) => {
          filterObject5.group.push(item.id);
        });
      }
      if (normative_is_active.length > 0) {
        normative_is_active.map((item) => {
          filterObject6.normative_is_active.push(item);
        });
      }
      if (values.length > 0) {
        values.map((item) => {
          filterObject7.values.push(item);
        });
      }
      if (component.length > 0) {
        component.map((item) => {
          filterObject8.component.push(item.id);
        });
      }
      if (type_dail) {
        filterObject.type_dail = type_dail;
      }

      if (!this.formData.ignore_date) {
        filterObject.start_date = moment(
          this.formData.start_date,
          "DD-MM-YYYY"
        ).format("YYYY-MM-DD");
        filterObject.end_date = moment(
          this.formData.end_date,
          "DD-MM-YYYY"
        ).format("YYYY-MM-DD");
      }
      this.sidebarState = false;
      this.$emit("get-data", {
        ...filterObject,
        ...filterObject1,
        ...filterObject2,
        ...filterObject3,
        ...filterObject4,
        ...filterObject5,
        ...filterObject6,
        ...filterObject7,
        ...filterObject8,
        ...filterObject9,
      });
    },
    clearFilter(val) {
      if (val === "x") {
        this.sidebarState = false;
      }
      if (val !== "x") {
        this.$emit("get-data", {});
      }
      this.formData = {
        group: [],
        type_dail: null,
        values: [],
        normative_is_active: [],
        region: [],
        parent_region: [],
        danger_category: [],
        status: [],
        objectSelected: [],
        start_date: moment().format("DD-MM-YYYY"),
        end_date: moment().format("DD-MM-YYYY"),
        ignore_date: true,
        component: [],
      };
      this.subsectionSelected = {
        id: 1,
        label: "Общесанитарные показатели",
        selected: "sanitary",
      };
      this.objectsList = [];
      this.objectsCount = 0;
      // this.submitHandler();
    },
    infClearPage() {
      this.$refs.infSelect.setPage();
    },

    getChildRegionsList() {
      if (!this.formData.parent_region.length) {
        this.selectedDistrictIds.region_id = [999];
        this.fetchChildRegions({ region_id: [999] });
        return;
      }

      this.formData.region = [];
      this.childRegions = [];
      this.objectsList = [];
      this.objectsCount = 0;
      let a = { region_id: [] };
      if (this.formData.parent_region.length > 0) {
        this.formData.parent_region.map((item) => {
          a.region_id.push(item.id);
        });
      }
      this.selectedDistrictIds.region_id = a.region_id;
      this.fetchChildRegions(a);
    },

    fetchChildRegions(a) {
      this.$store.dispatch("libraries/fetchChildRegions", a).then((res) => {
        this.childRegions = new Array();
        this.childRegions.push(...res.data.data);
      });
    },

    async objectFetchWithFilter() {
      this.formData.objectSelected = [];
      let dataRegion = { region_id: [] };
      if (this.formData.region.length > 0) {
        this.formData.region.map((item) => {
          dataRegion.region_id.push(item.id);
        });
      } else if (this.formData.parent_region.length > 0) {
        this.formData.parent_region.map((item) => {
          dataRegion.region_id.push(item.id);
        });
      } else {
        dataRegion.region_id = null;
      }
    },
  },
};
</script>

<style lang="scss">
.sidebarFilter {
  .vs-sidebar {
    max-width: 25%;
    z-index: 99999; //z-index filter
    &--items {
      padding: 0;
    }
  }
}

.header-sidebar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  h4 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    > button {
      margin-left: 10px;
    }
  }
}

.footer-sidebar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  > button {
    border: 0px solid rgba(0, 0, 0, 0) !important;
    border-left: 1px solid rgba(0, 0, 0, 0.07) !important;
    border-radius: 0px !important;
  }
}

.vs-sidebar .vs-sidebar--items {
  overflow: scroll !important;
}

.btn-float-fix {
  float: left !important;
}
</style>
